import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import LoginForm from '../Pages/LoginForm';

function PublicLayout() {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const location = useLocation();

  const handleLoginClick = () => {
    setIsLoginMode(true);
    setIsLoginModalOpen(true);
  };

  const handleSignUpClick = () => {
    setIsLoginMode(false);
    setIsLoginModalOpen(true);
  };

  return (
    <div className='min-h-screen flex flex-col'>
      <Header
        user={user}
        setUser={setUser}
        onLoginClick={handleLoginClick}
        onSignUpClick={handleSignUpClick}
      />
      <LoginForm
        isModalOpen={isLoginModalOpen}
        closeModal={() => setIsLoginModalOpen(false)}
        isLoginDefault={isLoginMode}
        setUser={setUser}
        redirectPath={location.pathname}
      />
      <main className='flex-grow min-h-screen'>
        {/* Pass login functions to Cart component when on cart route */}
        {location.pathname === '/cart' ? (
          <Outlet context={{ 
            onLoginClick: handleLoginClick, 
            onSignUpClick: handleSignUpClick,
            user: user 
          }} />
        ) : (
          <Outlet />
        )}
      </main>
      <Footer></Footer>
    </div>
  );
}

export default PublicLayout;